import React, { useEffect } from "react";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import BaseField from "components/util/schema_form/fields/BaseField";
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import l from "components/util/l"

const icon = <i className="far fa-circle" />;
const checkedIcon = <i className="fas fa-circle-check" />;


const OptionItem = ({ label, icon, disabled, isOnSelector = false, className = "", style = {} }) =>
	<div className={className}
		style={{
			pointerEvents: "none",
			color: "#777", fontSize: "1rem",
			...isOnSelector
				? {
					position: "absolute",
					marginTop: "-2.55rem",
					marginLeft: "1rem",
					background: disabled ? "#f8fafd" : "#fff"
				}
				: {}
		}}>
		{icon ? <i className={icon + " mr-3"} style={{ color: "#888" }}></i> : null}
		<span style={{ color: "#606a70", fontSize: "0.9em" }}>{label}</span>
	</div>


const SelectField = ({
	name,
	label,
	options,
	selectType = "dropdown",
	multiple = false,
	value,
	values,
	defaultValue,
	required,
	disabled,
	openText,
	placeholder = "Selecciona una opción%GA025",
	caption,
	helpMessage,
	enableComments,
	setFieldValue,
	onChange = () => { },
	onOpen = () => { },
}) => {

	useEffect(() => {
		if (value === undefined && defaultValue != null &&
			options.find((option) => option.value == defaultValue) != null)
			setFieldValue(name, defaultValue)
	}, [defaultValue])

	const getLabelName = (value) => {
		let opt = options.find((option) => option.value == value)
		return opt?.label ?? value;
	}

	const onChangeValue = (newValue) => {
		if (multiple) {
			let selected = value || [];
			let pos = selected.indexOf(newValue);
			if (pos == -1) selected.push(newValue);
			else selected.splice(pos, 1);
			setFieldValue(name, selected);
			let labels = options.filter(item => selected.indexOf(item.value) != -1).map(item => item.label)
			onChange(selected, labels)
		}
		else {
			let label = options.find(item => item.value == newValue)?.label
			setFieldValue(name, newValue);
			onChange(newValue, label)
		}

	}
	return (
		<BaseField
			name={name}
			label={label}
			values={values}
			required={required}
			caption={caption}
			helpMessage={helpMessage}
			enableComments={enableComments}
			setFieldValue={setFieldValue}
		>
			<div className="w-100">
				{selectType == "dropdown" && (
					<Autocomplete
						id={name}
						freeSolo={openText}
						forcePopupIcon
						value={value}
						multiple={multiple}
						options={options.map((item) => item.value)}
						required={required}
						disabled={disabled}
						onOpen={onOpen}
						getOptionLabel={(option) => getLabelName(option)}
						renderTags={(value, getTagProps) =>
							value.map((option, index) => {
								const optionItem = options.find((item) => item.value == option)
								return (
									<Chip
										key={index}
										label={optionItem?.label ?? option}
										{...getTagProps({ index })}
										icon={optionItem?.icon ? <i className={optionItem?.icon + " px-1"} style={{ color: "#888" }}></i> : <span></span>}
									/>
								)
							})
						}
						renderInput={(params) => {
							let selectedOption = options.find((option) => option.value == value)
							if (selectedOption != null && !multiple)
								params.inputProps.value = selectedOption?.label ?? selectedOption?.value
							else params.inputProps.value = ""

							return (<div className="w-100">
								<TextField {...params} variant="outlined" placeholder={l(placeholder)} type="text"
									className={(!openText ? "no-autocomplete " : " ") +
										(selectedOption && !multiple ? "hidden-input " : " ")} />
								{(selectedOption && !multiple) ?
									<OptionItem
										label={getLabelName(selectedOption.value)}
										icon={selectedOption?.icon}
										disabled={disabled}
										isOnSelector={true}
										className={"d-flex align-items-center px-1 py-2"}
									/> : null}
							</div>
							)
						}}
						renderOption={(option, { selected }) => {
							let optionItem = options.find((item) => item.value == option)
							return (
								<React.Fragment>
									{multiple && (
										<Checkbox
											icon={icon}
											color="primary"
											checkedIcon={checkedIcon}
											style={{ marginRight: 8 }}
											checked={selected}
										/>
									)}
									<OptionItem
										disabled={disabled}
										label={getLabelName(option)}
										icon={optionItem?.icon}
										className={"d-flex align-items-center px-1 py-2"}
									/>
								</React.Fragment>
							)
						}}
						onChange={(event, newValue) => onChangeValue(newValue)}
						onInputChange={(event, newValue) => { if (openText) onChangeValue(newValue) }}
						style={{ width: "100%" }}
					/>
				)}

				{selectType == "list" && (
					<div>
						{multiple ? (
							<div>
								{options.map((option, idx) => {
									const randomStr = Math.random().toString(36).substring(2, 10);
									const autogeneratedId = `name-${option.value.replace(" ", "-")}-${randomStr}`;
									return (
										<div class="form-group mb-1" key={idx}>
											<div class="custom-control custom-checkbox">
												<input type="checkbox" id={autogeneratedId} class="custom-control-input" disabled={disabled}
													onChange={(event) => onChangeValue(event.target.value)} value={option.value} checked={value?.includes(option.value)}
												/>
												<label class="custom-control-label" for={autogeneratedId}>
													<OptionItem disabled={disabled} label={getLabelName(option.value)} icon={option?.icon}
														className={"d-flex align-items-center px-1"}
													/>
												</label>
											</div>
										</div>
									)
								})}
							</div>
						) : (
							<div>
								{options.map((option, idx) => {
									const randomStr = Math.random().toString(36).substring(2, 10);
									const autogeneratedId = `name-${option.value.replace(" ", "-")}-${randomStr}`;
									return (
										<div class="form-group mb-1" key={idx}>
											<div class="custom-control custom-radio">
												<input type="radio" id={autogeneratedId} class="custom-control-input" name={name}
													onChange={(event) => onChangeValue(event.target.value)} value={option.value} disabled={disabled} checked={value == option.value}
												/>
												<label class="custom-control-label" for={autogeneratedId}>
													<OptionItem disabled={disabled} label={getLabelName(option.value)} icon={option?.icon}
														className={"d-flex align-items-center px-1"}
													/>
												</label>
											</div>
										</div>
									)
								})}
							</div>
						)}
					</div>
				)}

			</div>
		</BaseField>
	)
}

export default SelectField;